import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ClassStatement } from '@program-suite/data-common';
import { IconComponent } from '@program-suite/util-icons';

@Component({
  selector: 'lib-class-accordion',
  imports: [IconComponent],
  templateUrl: './class-accordion.component.html',
  styleUrl: './class-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassAccordionComponent {
  accordions = input<ClassStatement[]>([]);
  activeIndex: number | null = null;
  toggleAccordion(index: number) {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
}
